import { AfterViewInit, Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { SuccessComponent } from "../success.interface";
import { Fiat, Offer, PayoutProvider } from "@models";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { FiatTransaction } from "@models/transaction";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { SegmentService } from "@main-services/segment.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { TradeBuyComponent } from "@modules/trade/modals/trade-buy-modal/trade-buy-modal.component";
import { TradeSellComponent } from "@modules/trade/modals/trade-sell-modal/trade-sell.component";
import { MODAL_ANIMATION_TIMEOUT } from "@helpers/constants";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "fiat-transaction-success",
	templateUrl: "./fiat-transaction-success.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class FiatTransactionSuccessComponent extends SuccessComponent implements AfterViewInit {
	@Input()
	public fiatTransaction: FiatTransaction = null;

	public constructor(
		protected router: Router,
		protected fiatService: FiatService,
		protected accountService: AccountService,
		protected tradableListService: TradableListService,
		protected masterdataService: MasterdataService,
		protected segmentService: SegmentService,
		protected rudderstackService: RudderstackService
	) {
		super(fiatService, tradableListService, accountService, router, segmentService, rudderstackService);
	}

	public ngAfterViewInit(): void {
		if (this.isSendFiat) {
			this.flowName = "Send Fiat";
			this.pathPrepend = "/send/fiat";
		} else {
			this.flowName = "Fiat Deposit";
			this.pathPrepend = "/deposit/fiat";
		}
		super.ngAfterViewInit();
	}

	public goToWallet(): void {
		this.close("redirect");
		setTimeout(() => {
			this.router.navigateByUrl(/fiat-wallet/ + this.fiatTransaction.getFiatWalletId());
		}, 300);
	}

	public get fiat(): Fiat {
		if (!this.fiatTransaction) {
			return new Fiat();
		}
		return this.fiatService.getItemById(this.fiatTransaction.getFiatId());
	}

	public get isSendFiat(): boolean {
		if (this.fiatTransaction) {
			const provider = this.masterdataService.payout_providers.find(
				(p: PayoutProvider) => p.getId() === this.fiatTransaction.getPayoutProviderId()
			);
			if (provider) {
				return provider.sendEnabled(true);
			}
		}
		return false;
	}

	public tradeMore(useCase: string = "buy"): void {
		this.close();
		const data = new Offer();

		if (useCase === "sell") {
			data.setType(TRADE_TYPE.SELL);
			setTimeout(() => {
				// The Backbutten handling in Modals screws this if you dont delay it a little
				this.modalService.create(TradeSellComponent, { data: data }).present();
			}, MODAL_ANIMATION_TIMEOUT);
		} else {
			setTimeout(() => {
				this.modalService.create(TradeBuyComponent, { data: data }).present();
			}, MODAL_ANIMATION_TIMEOUT);
		}
	}
}
